require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-emedicinehealth-diagnosis.json") })
        }
      }, "path---article-emedicinehealth-diagnosis");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-emedicinehealth-diagnosis!./.cache/json/article-emedicinehealth-diagnosis.json
// module id = 339
// module chunks = 231608221292675